import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Masonry from "@mui/lab/Masonry";
import Box from "@mui/material/Box";
import { useState } from "react";
import { Modal } from "../../components/Modal";
import "./style.css";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useMediaQuery } from "react-responsive";
import ImageFadeIn from "../../components/ImageFadeIn";
import ElementFadeIn from "../../components/ElementFadeIn";
import { Button } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const GameCard = (props) => {
    const { game, onPlay } = props;
    const [color, setColor] = useState("#ffbfbf");
    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ minWidth: 900 });
    const sm = useMediaQuery({ maxWidth: 767 });
    console.log(game);

    React.useEffect(() => {
        setColor(getRandomLightColor());
    }, []);

    const getRandomLightColor = () => {
        // Generate a random light color in HSL format
        const hue = Math.floor(Math.random() * 360);
        const saturation = Math.floor(Math.random() * 50) + 50; // Ensure a minimum saturation of 50%
        const lightness = Math.floor(Math.random() * 25) + 75; // Bias towards higher lightness values

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    };

    const handleClick = () => {
        onPlay(game);
    };
    return (
        <ElementFadeIn>
            <div className="w-dyn-item">
                <div style={{ backgroundColor: color }} className="people-card">
                    <div className="people-headshot-wrapper">
                        <img
                            alt=""
                            loading="lazy"
                            src={process.env.REACT_APP_CLOUD_FRONT_URL + game.coverImage}
                            sizes="(max-width: 479px) 57vw, (max-width: 767px) 43vw, 26vw"
                            className="cover-image"></img>

                        <div
                            className="headshot-mask"
                            style={{ willChange: "width, height", width: "100%", height: "22.3333%" }}>
                            <div style={{ backgroundColor: color }} className="hm-part-1"></div>
                            <div style={{ backgroundColor: color }} className="hm-part-2"></div>
                        </div>
                    </div>
                    <div className="people-info">
                        <div className="margin-tiny">
                            <div className="text-xl inline-text">{game.name}</div>
                        </div>
                        <Button
                            sx={{
                                border: "1px solid black",
                                borderRadius: "8px",
                                fontWeight: "400",
                                color: "black",
                                letterSpacing: "1.5px",
                                "&:hover": { border: "1px solid black", background: "rgba(0,0,0,.1)" },
                            }}
                            variant="outlined"
                            startIcon={<PlayArrowIcon />}
                            onClick={handleClick}>
                            Play
                        </Button>
                    </div>
                </div>
            </div>
        </ElementFadeIn>
    );
};

export { GameCard };
